var map = {
	"./AD.svg": "292f",
	"./AE.svg": "6a71",
	"./AF.svg": "367d",
	"./AG.svg": "f07e",
	"./AI.svg": "df26",
	"./AL.svg": "26c4",
	"./AM.svg": "0571",
	"./AN.svg": "1eff",
	"./AO.svg": "d265",
	"./AR.svg": "a12a",
	"./AS.svg": "20f9",
	"./AU.svg": "3aed",
	"./AUT.svg": "3984",
	"./AW.svg": "b42f",
	"./AX.svg": "7486",
	"./AZ.svg": "8446",
	"./BA.svg": "62d1",
	"./BB.svg": "21c8",
	"./BD.svg": "df8d",
	"./BEL.svg": "4544",
	"./BF.svg": "f700",
	"./BGR.svg": "a47c",
	"./BH.svg": "c8e1",
	"./BI.svg": "c86d",
	"./BJ.svg": "7dfc",
	"./BM.svg": "3947",
	"./BN.svg": "a2e5",
	"./BO.svg": "a257",
	"./BR.svg": "2a6d",
	"./BS.svg": "e394",
	"./BT.svg": "1bff",
	"./BV.svg": "85a3",
	"./BW.svg": "868f",
	"./BY.svg": "e3d4",
	"./BZ.svg": "a3e0",
	"./CA.svg": "6a66",
	"./CD.svg": "8e5e",
	"./CF.svg": "7e1e",
	"./CG.svg": "39cb",
	"./CHE.svg": "d68d",
	"./CI.svg": "b2bd",
	"./CK.svg": "1ee0",
	"./CL.svg": "d4fc",
	"./CM.svg": "f4dc",
	"./CN.svg": "dcd8",
	"./CO.svg": "9b06",
	"./CR.svg": "7bb4",
	"./CU.svg": "21ae",
	"./CV.svg": "d923",
	"./CW.svg": "bf92",
	"./CYP.svg": "948f",
	"./CZE.svg": "a486",
	"./DEU.svg": "5814",
	"./DJ.svg": "e86f",
	"./DM.svg": "5e33",
	"./DNK.svg": "fb46",
	"./DO.svg": "ed84",
	"./DZ.svg": "7d22",
	"./EC.svg": "7ae4",
	"./EG.svg": "1acb",
	"./EH.svg": "1075",
	"./ER.svg": "5134",
	"./ESP.svg": "c161",
	"./EST.svg": "df72",
	"./ET.svg": "09cc",
	"./EU.svg": "5bc1",
	"./FIN.svg": "2cf6",
	"./FJ.svg": "d128",
	"./FK.svg": "cafb",
	"./FM.svg": "dae1",
	"./FRA.svg": "d390",
	"./GA.svg": "287e",
	"./GBR.svg": "0cdd",
	"./GD.svg": "b88e1",
	"./GE.svg": "ccbf",
	"./GG.svg": "78a7",
	"./GH.svg": "2c14",
	"./GI.svg": "ea7c",
	"./GM.svg": "ca5f",
	"./GN.svg": "57a5",
	"./GP.svg": "9737",
	"./GQ.svg": "732b",
	"./GRC.svg": "05cd",
	"./GT.svg": "0c58",
	"./GU.svg": "0c61",
	"./GW.svg": "660b",
	"./GY.svg": "1420",
	"./HK.svg": "23bb",
	"./HN.svg": "c8ab",
	"./HRV.svg": "6748",
	"./HT.svg": "8d27",
	"./HUN.svg": "31d2",
	"./ID.svg": "b7a6",
	"./IL.svg": "7214",
	"./IM.svg": "995d",
	"./IN.svg": "c4f7",
	"./IQ.svg": "75cb",
	"./IR.svg": "3708",
	"./IRL.svg": "9e93",
	"./ISL.svg": "0157",
	"./ITA.svg": "faf7",
	"./JE.svg": "7eea",
	"./JM.svg": "a94c",
	"./JO.svg": "06ae",
	"./JP.svg": "f355",
	"./KE.svg": "fd12",
	"./KG.svg": "19ce",
	"./KH.svg": "0cd4",
	"./KI.svg": "614e",
	"./KM.svg": "cb5b",
	"./KN.svg": "7c9f",
	"./KP.svg": "f1a0",
	"./KR.svg": "d0c5",
	"./KW.svg": "959c",
	"./KY.svg": "0966",
	"./KZ.svg": "6f5d",
	"./LA.svg": "6358",
	"./LB.svg": "0e0d",
	"./LC.svg": "19e5",
	"./LI.svg": "6881",
	"./LK.svg": "eedb",
	"./LR.svg": "5be2",
	"./LS.svg": "5d65",
	"./LTU.svg": "b3ef",
	"./LUX.svg": "0c6c",
	"./LVA.svg": "e82e",
	"./LY.svg": "bbfd",
	"./MA.svg": "bc14",
	"./MC.svg": "66d16",
	"./MD.svg": "70b9",
	"./ME.svg": "3bb3",
	"./MF.svg": "d26d",
	"./MG.svg": "b332",
	"./MK.svg": "b6bf",
	"./ML.svg": "4765",
	"./MLT.svg": "087d",
	"./MM.svg": "50d5",
	"./MN.svg": "8a9e",
	"./MO.svg": "c52c",
	"./MR.svg": "bc94",
	"./MS.svg": "941f",
	"./MU.svg": "27b4",
	"./MV.svg": "fe1d",
	"./MW.svg": "0fe9",
	"./MX.svg": "90e9",
	"./MY.svg": "7a1d",
	"./MZ.svg": "2f16",
	"./NA.svg": "74e4",
	"./NC.svg": "7aa9",
	"./NE.svg": "fd99",
	"./NF.svg": "ce40",
	"./NG.svg": "6708",
	"./NI.svg": "b501",
	"./NLD.svg": "8b45",
	"./NOR.svg": "2e25",
	"./NP.svg": "612c",
	"./NR.svg": "1301",
	"./NZ.svg": "af25",
	"./OM.svg": "aa30",
	"./PA.svg": "4277",
	"./PE.svg": "ddd8",
	"./PF.svg": "fec7",
	"./PG.svg": "60f0",
	"./PH.svg": "c6f0",
	"./PK.svg": "77dd",
	"./POL.svg": "d334",
	"./PR.svg": "646e",
	"./PRT.svg": "c833",
	"./PS.svg": "6ae1",
	"./PW.svg": "4771",
	"./PY.svg": "35d6",
	"./QA.svg": "2cc2",
	"./ROU.svg": "a058",
	"./RU.svg": "b3a3",
	"./RW.svg": "8238",
	"./SA.svg": "294d",
	"./SB.svg": "5e7b",
	"./SC.svg": "2d51",
	"./SD.svg": "6ea9",
	"./SG.svg": "5273",
	"./SH.svg": "71e5",
	"./SL.svg": "a4c7",
	"./SM.svg": "00be",
	"./SN.svg": "8534",
	"./SO.svg": "f58e",
	"./SR.svg": "4313",
	"./SRB.svg": "1546",
	"./ST.svg": "42c8",
	"./SV.svg": "ec83",
	"./SVK.svg": "e405",
	"./SVN.svg": "9558",
	"./SWE.svg": "990b",
	"./SY.svg": "49bc",
	"./SZ.svg": "0257",
	"./TC.svg": "c957",
	"./TD.svg": "d7d4",
	"./TG.svg": "ab70",
	"./TH.svg": "9a74",
	"./TJ.svg": "ad5d",
	"./TL.svg": "3ba3",
	"./TM.svg": "4dbf",
	"./TN.svg": "0bce",
	"./TO.svg": "5f94",
	"./TR.svg": "5067c",
	"./TT.svg": "26476",
	"./TV.svg": "bcc1",
	"./TW.svg": "c7ed",
	"./TZ.svg": "18cb",
	"./UA.svg": "2bd4",
	"./UG.svg": "bea5",
	"./US.svg": "396d",
	"./UY.svg": "5156",
	"./UZ.svg": "4d86",
	"./VC.svg": "96ec",
	"./VE.svg": "d5e7",
	"./VG.svg": "7b9c",
	"./VI.svg": "23ce",
	"./VN.svg": "b6f7",
	"./VU.svg": "d135",
	"./WS.svg": "7179",
	"./YE.svg": "15c4",
	"./ZA.svg": "ae58",
	"./ZM.svg": "bb50",
	"./ZW.svg": "a7e4",
	"./un.svg": "f5ff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8e83";